<script>
export default {
  data() {
    return {
      loading: true,
      afiliado: null,
      stats: {
        total_leads:      0,
        total_converted:  0,
        commission_total: 0,
      },
    };
  },
  created() {
    if (!localStorage.getItem("afiliado_token")) {
      this.$router.push("/login/afiliado");
      return;
    }
    const stored = localStorage.getItem("afiliado");
    if (stored) {
      this.afiliado = JSON.parse(stored);
    }
    this.loading = false;
  },
  methods: {
    logout() {
      this.$store.dispatch("afiliadoAuth/logout");
      this.$router.push("/login/afiliado");
    },
  },
};
</script>

<template>
  <div class="d-flex flex-column min-vh-100 bg-light">
    <!-- Navbar simples -->
    <nav class="navbar navbar-light bg-white shadow-sm px-4">
      <span class="navbar-brand font-weight-bold">
        <img src="@/assets/images/logo.png" height="32" class="mr-2" />
        Painel do Afiliado
      </span>
      <div class="d-flex align-items-center">
        <span v-if="afiliado" class="mr-3 text-muted small">{{ afiliado.name }}</span>
        <b-nav>
          <b-nav-item to="/afiliado/leads">Meus Leads</b-nav-item>
          <b-nav-item to="/afiliado/comissoes">Comissões</b-nav-item>
        </b-nav>
        <b-button size="sm" variant="outline-secondary" class="ml-3" @click="logout">Sair</b-button>
      </div>
    </nav>

    <!-- Content -->
    <div class="container py-5">
      <div v-if="loading" class="text-center py-5">
        <b-spinner variant="primary"></b-spinner>
      </div>
      <div v-else>
        <h4 class="mb-4">Bem-vindo, {{ afiliado ? afiliado.name : '' }}!</h4>

        <b-row>
          <b-col md="4" class="mb-4">
            <div class="card shadow-sm text-center py-4">
              <div class="display-4 text-primary font-weight-bold">{{ stats.total_leads }}</div>
              <div class="text-muted mt-1">Total de Leads Indicados</div>
            </div>
          </b-col>
          <b-col md="4" class="mb-4">
            <div class="card shadow-sm text-center py-4">
              <div class="display-4 text-success font-weight-bold">{{ stats.total_converted }}</div>
              <div class="text-muted mt-1">Leads Convertidos</div>
            </div>
          </b-col>
          <b-col md="4" class="mb-4">
            <div class="card shadow-sm text-center py-4">
              <div class="display-4 text-warning font-weight-bold">
                R$ {{ parseFloat(stats.commission_total).toFixed(2).replace(".", ",") }}
              </div>
              <div class="text-muted mt-1">Comissão a Receber</div>
            </div>
          </b-col>
        </b-row>

        <div class="alert alert-info mt-2">
          <i class="mdi mdi-information-outline mr-1"></i>
          Em breve: indicação de leads e acompanhamento de comissões em tempo real.
        </div>
      </div>
    </div>
  </div>
</template>
